export { default as capitalize } from './capitalize';
export { default as deprecatedPropType } from './deprecatedPropType';
export { default as isMuiElement } from './isMuiElement';
export { default as ownerDocument } from './ownerDocument';
export { default as ownerWindow } from './ownerWindow';
export { default as requirePropFactory } from './requirePropFactory';
export { default as setRef } from './setRef';
export { default as unsupportedProp } from './unsupportedProp';
export { default as useEventCallback } from './useEventCallback';
export { default as useForkRef } from './useForkRef';
export { default as useControlled } from './useControlled';
export { useIsFocusVisible } from './focusVisible';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/utils/index.js
// module id = 852
// module chunks = 0